import { X } from "lucide-react";

export const Sheet = ({ title, onClose, top, testId, children }) => (
  <div className={`fixed inset-0 z-[60] bg-[#0B1D3A]/70 flex justify-center p-4 animate-in fade-in duration-200 ${top ? "items-start pt-8" : "items-end pb-8"}`} onClick={onClose} data-testid={testId}>
    <div className="bg-white w-full max-w-sm rounded-3xl p-6 shadow-2xl animate-in slide-in-from-bottom-4 duration-300" onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center gap-3">
        <img src="/icons/icon-192.png" alt="" className="w-12 h-12 rounded-xl border border-slate-200 shrink-0" />
        <h3 className="flex-1 font-display font-black text-2xl leading-tight text-[#0B1D3A]">{title}</h3>
        <button onClick={onClose} aria-label="Cerrar" className="p-1 text-slate-500 hover:text-[#B23A38]" data-testid={`${testId}-close`}><X size={24} /></button>
      </div>
      {children}
    </div>
  </div>
);

export const VisualStep = ({ n, icon, children, red }) => (
  <li className="flex items-center gap-4">
    <span className="relative shrink-0">
      <span className={`w-14 h-14 rounded-2xl grid place-items-center ${red ? "bg-[#B23A38] text-white" : "bg-[#EAF3F9] text-[#3D88B8]"}`}>{icon}</span>
      <span className="absolute -top-2 -left-2 w-6 h-6 rounded-full bg-[#0B1D3A] text-white text-xs font-bold grid place-items-center">{n}</span>
    </span>
    <span className="text-lg leading-snug text-slate-800">{children}</span>
  </li>
);

export const Primary = ({ as: Tag = "button", children, ...p }) => (
  <Tag {...p} className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-[#B23A38] hover:bg-[#962F2D] active:scale-[0.98] text-white font-bold text-xl py-4 rounded-full shadow-lg transition-[background-color,transform]">{children}</Tag>
);

export const Later = (p) => (
  <button {...p} className="mt-3 w-full text-center text-slate-500 font-semibold py-2 hover:text-[#0B1D3A] transition-colors">Seguir sin instalar</button>
);
